module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche B1 (Version 2).35ae925f27564f0a3939e701f0da8189.pdf";